import React from "react";
import EmptyIcon from "../../../images/orders/empty.svg"
const EmptyCalculator = () => {
  return (
    <div className="px-[60px]">
      <div className="h-[500px] flex flex-col items-center justify-center">
        <img src={EmptyIcon} alt="Empty State Icon" className="w-20 h-20" />
        <div className="h-5" />
        <p className="text-[16px] font-semibold text-p300">Nothing to show!</p>
        <div className="h-2.5" />
        <p className="text-[14px] font-semibold text-n500 text-center">
          Please fill in the fields at left to compute and present the data!
        </p>
      </div>
    </div>
  );
};

export default EmptyCalculator;
